var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KycBasicInfoLayout',{key:JSON.stringify(_vm.storedForm),attrs:{"isLoading":_vm.isLoading,"storedForm":_vm.storedForm},on:{"onNext":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }